import { render, staticRenderFns } from "./FunelChart.vue?vue&type=template&id=6108c685&"
import script from "./FunelChart.vue?vue&type=script&lang=js&"
export * from "./FunelChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports